module.exports = __webpack_public_path__ + "img/8.d890fe32.jpg";